import React from 'react';
import SvgIcon from './SvgIcon';

const AddCircle = props => {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M12 23.25c6.213 0 11.25-5.037 11.25-11.25S18.213.75 12 .75.75 5.787.75 12 5.787 23.25 12 23.25zM18 12H6m6-6v12V6z"
                stroke="currentColor"
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

AddCircle.displayName = 'AddCircleIcon';

export default AddCircle;
